<template>
  <button @click="getToken" v-if="showBtn" type="button" class="btn btn-outline-info"><i class="bi bi-telegram"></i> Подключить Telegram</button>
  <div class="row mb-3">
    <label id="link" class="col-md-4 col-lg-3 col-form-label">
      <a id="link" v-if="tgToken !== ''" :href="`https://t.me/finplansbot?start=${tgToken}`" class="btn btn-outline-primary"><i class="bi bi-telegram"></i> Перейти</a>
    </label>
    <div class="col-md-8 col-lg-9" v-if="tgToken !== ''">
      <input disabled v-model="tgToken" name="token" type="text" class="form-control" id="token" value="">
    </div>
  </div>
</template>

<script setup>
import { usePersonal } from '@/features/personal/composables/usePersonal';
import {onMounted, ref} from "vue";

const {
    tgToken,
    tgError,
    tgIsConfirmed,
    isTelegramConfirmed,
    getTgToken,
} = usePersonal();
const showBtn = ref(true);

onMounted(async () => {
  await isTelegramConfirmed();
});

async function getToken() {
  showBtn.value = false;
  await getTgToken();
}

</script>
